import { render } from "./createToDo.vue?vue&type=template&id=93e99170&ts=true"
import script from "./createToDo.vue?vue&type=script&lang=ts"
export * from "./createToDo.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__